import { Component, Injectable, OnInit } from '@angular/core'

@Injectable()
@Component({
    selector: 'soaviewagentconf',
        templateUrl: 'soa-view-returntoagent-confirmation.html',
        styleUrls: ['soa-form-submission.component.scss']
})
export class SOAViewReturnToAgentConfirmationComponent implements OnInit {


    ngOnInit() {

    }

}
